<div class="result-header-container" [class.with-sort]="showSort" [class.with-context-menu]="showResultSections?.showContextMenu">
  <div class="result-header" [attr.data-cy]="'header-item-' + model?.title" [ngClass]="{ 'header-date': isHeaderDate, selected: selected }">
    <div>
      <ng-container>
        <div class="result-header-content headline-2" [class.space]="showRightButton && model?.textButton">
          <u-icon
            class="left-header-icon"
            *ngIf="model.leftIcon"
            [model]="{ type: 'font', value: model.leftIcon }"
            [styles]="model?.leftIconStyles"
          ></u-icon>
          <div class="header" [class.clickable]="model?.clickable" (click)="model?.clickable && focusGroupClick.emit($event)">
            <div class="header-title" [ngClass]="{ 'header-date': isHeaderDate, footer: footer || model?.isFooter }">
              {{ model?.title }}
            </div>
            <div *ngIf="model?.titleHighlight" class="header-highlight-title">
              {{ model?.titleHighlight }}
            </div>
            <div class="header-title-end">
              {{ model?.titleEnd }}
            </div>
            <i *ngIf="model?.icon" [class]="model?.icon"></i>
          </div>
          <u-button
            [attr.data-cy]="'header-item-btn-' + model.title"
            *ngIf="showRightButton && model?.textButton"
            class="no-state"
            elementSize="very-small"
            type="secondary"
            [label]="model?.textButton | titlecase"
            (onClick)="buttonClicked.emit($event)"
          ></u-button>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="showLauncherButton" (click)="openCollectionExternal.emit()" class="open-external-link">
    <u-icon [model]="{ type: 'font', value: 'icon-launch' }"></u-icon>
    <span>{{ launcherButtonText }}</span>
  </div>

  <u-button
    *ngIf="showSort"
    #sortButtonRef
    class="sort-icon"
    elementSize="small"
    fontIcon="sort-list-down"
    type="secondary"
    [class.sort-active]="!!sortService.popupRefSort || !!searchParamsService.getSort()"
    [styles]="{ fontSize: '14px', height: '28px', width: '28px' }"
    (onClick)="openSort(sortButtonRef)"
  ></u-button>

  <square-button
    *ngIf="showResultSections?.showContextMenu"
    [active]="contextMenuActive"
    class="square-button"
    [ngClass]="{ visible: contextMenuActive }"
    (click)="$event.stopPropagation(); openContextMenu($event)"
    (auxclick)="$event.stopPropagation(); openContextMenu($event)"
    (contextmenu)="$event.stopPropagation(); openContextMenu($event)"
    #actions
    data-cy="search-results-actions-kebab"
    >•••</square-button
  >
</div>
